import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
    apiKey: "AIzaSyBpGPDrvKuPmBbvfEXOnJVqm-O81JSMdJ4",
    authDomain: "teamlog-vue.firebaseapp.com",
    databaseURL: "https://teamlog-vue-default-rtdb.firebaseio.com",
    projectId: "teamlog-vue",
    storageBucket: "teamlog-vue.appspot.com",
    messagingSenderId: "933961710181",
    appId: "1:933961710181:web:32b6443c053e6ebcd6e48c",
  };

const firebase = initializeApp(firebaseConfig);
const database = getDatabase(firebase);


createApp(App).use(router).mount('#app')
